import { render, staticRenderFns } from "./TemplateObjectType.vue?vue&type=template&id=0b2cbb3e&"
import script from "./TemplateObjectType.vue?vue&type=script&lang=js&"
export * from "./TemplateObjectType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./TemplateObjectType.vue?vue&type=custom&index=0&blockType=messages"
if (typeof block0 === 'function') block0(component)

export default component.exports